import React from "react";
import ChqModalDialog from "components/common/ChqModalDialog";
import ProgressLine from "components/admin/analytics/ProgressLine";
import ModalHeaderToggle from "./ModalHeaderToggle";
import UserInformationForm from "../UserInformation/UserInformationForm";
import { usePostStoryContext } from "../../contexts/PostStoryContext";
import PostStoryForm from "../PostStoryForm/PostStoryForm";

const PostStoryModal: React.FC = () => {
  const {
    state: { userInformationRequest, progress },
    onConfirmClose
  } = usePostStoryContext();

  return (
    <>
      <ChqModalDialog
        entrance="zoomIn"
        onClose={onConfirmClose}
        className="post-story-modal"
        ariaLabelledBy="post-story-title"
        ariaDescribedby="post-story-title"
      >
        <ModalHeaderToggle />
        {!userInformationRequest && (<PostStoryForm />)}
        {userInformationRequest && <UserInformationForm />}
        {progress !== 0 && (
          <ProgressLine
            className="story-progressbar"
            color="#79b17d"
            valueNow={progress}
            valueMax={100}
          />
        )}
      </ChqModalDialog>
    </>
  );
};

export default PostStoryModal;
